// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-1e01bd1c]{padding:8px}.container-lg[data-v-1e01bd1c]{max-width:1058px}.container-sm[data-v-1e01bd1c]{max-width:424px}.container-width-options button[data-v-1e01bd1c]{margin:0 8px}.board[data-v-1e01bd1c]{border:1px solid gray;margin:8px 0;padding:8px}.board input[data-v-1e01bd1c]{display:block;margin:8px 0;height:1.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
